module.exports = __webpack_public_path__ + "static/media/education.e3888f73.svg";